import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import {Headers, RequestOptions} from '@angular/http';
import { UtilsService } from '../../shared/utils-service';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';


@Injectable()
export class BatchUploadServiceService {

	//private url: string = this.utils.url+"/bulkBlackListSubmission/uploadBulkBlackListCustomers";
	private url: string = this.utils.url+"/bulkBlackListSubmission/uploadBulkBlackListCustomers";

	constructor(private http: Http, private utils: UtilsService) { }
	
	uploadFile(req,userId,token){
	console.log(req, 'req');
	var headers = new Headers();
	headers.append('userId', userId);
	headers.append('token', token);

		return this.http.post(this.url, req, { headers: headers });
			//.map(res => res.json());
	}
}


// WEBPACK FOOTER //
// ./src/app/mass-submit-telco/batch-upload/batch-upload.service.ts